<template>
  <div class="notice-board">
    <div class="notice-header">
      <span class="notice-title">{{ title }}</span>
      <span class="notice-more" @click="$emit('more')"
        >更多 <i class="iconfont el-icon-d-arrow-right"></i
      ></span>
      <div class="line"></div>
    </div>

    <div class="list">
      <img class="banner" src="@/assets/image/banner.webp" alt="" />
      <ul class="notice-list">
        <li
          v-for="(item, idx) in list"
          :key="idx"
          class="notice-item"
          @click="$emit('click', item)">
          <span class="notice-item-title" :title="item.title">{{
            item.title
          }}</span>
          <span class="notice-item-date">{{
            timeFormat(item.publishDate)
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeBoard",
  props: {
    title: {
      type: String,
      default: "通知公告",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // 时间格式化
    timeFormat(time) {
      return time.substring(0, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-board {
  width: 100%;
  height: 312px;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  background: #fff;
  padding: 18px 20px 12px 20px;
  box-sizing: border-box;
  .notice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    border-bottom: 1px solid #e1e1e1;
    padding: 10px 0;
    position: relative;
    .notice-title {
      font-weight: 600;
      font-size: 20px;
      color: #388ed5;
      line-height: 28px;
    }
    .line {
      width: 80px;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 4px;
      background: #388ed5;
    }
    .notice-more {
      font-size: 14px;
      color: #388ed5;
      line-height: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-left: 4px;
      }
    }
  }
  .list {
    display: flex;
    .banner {
      height: 208px;
      margin-right: 40px;
    }
  }

  .notice-list {
    flex: 1;
    list-style: none;
    padding: 0;
    margin: 0;
    .notice-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 0;
      font-size: 15px;
      border-bottom: 1px solid #f2f3f5;
      margin-bottom: 10px;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      .notice-item-title {
        flex: 1;
        width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 10px;

        font-size: 16px;
        color: #4a4a4a;
        line-height: 22px;
      }
      .notice-item-date {
        min-width: 80px;
        text-align: right;
        font-size: 14px;
        color: #9b9b9b;
        line-height: 20px;
      }
    }
  }
}
</style>
